import ContentHeader from './ContentHeader'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'

const mapStateToProps = state => {
  return {
    indicatorsData: state.INDICATORS.indicatorsData,
    lastUpdated: state.INDICATORS.lastUpdated
  }
}

export default withRouter(connect(mapStateToProps)(ContentHeader))



// WEBPACK FOOTER //
// ./src/modules/Content/ContentHeader/index.js